import styled from 'styled-components';

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  position: relative;

  .group {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .two-buttons {
    display: flex;
    gap: 4px;
    @media ${({ theme }) => theme.devices.mobile} {
      width: 100%;
    }

    p {
      color: ${({ theme }) => theme.colors.grey.white};
      text-transform: uppercase;
      margin-bottom: -2px;
    }

    svg {
      width: 24px;
      height: 24px;
      color: ${({ theme }) => theme.colors.grey.white};

      path {
        stroke-width: 3px;
      }
    }

    &[disabled] {
      transition: 0.7s;
      cursor: default;
    }

    max-width: 300px;
  }
`;

export const ButtonGoogle = styled.button`
  width: 100%;
  max-width: 450px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 0;
  padding: 16px 12px;
  gap: 8px;
  background-color: ${({ theme }) => theme.colors.grey.white};

  p {
    margin-bottom: -4px;
  }

  &:hover {
    transition: 0.7s;
    background-color: ${({ theme }) => theme.colors.grey[200]};
  }
`;

export const GroupButton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    p {
      color: ${({ theme }) => theme.colors.grey.white};
      text-transform: uppercase;
      margin-bottom: -2px;
    }

    svg {
      width: 24px;
      height: 24px;
      color: ${({ theme }) => theme.colors.grey.white};

      path {
        stroke-width: 3px;
      }
    }
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.grey[100]};
    text-decoration: underline;
    font-weight: 700;
    width: 100%;
    font-size: 20px;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 16px;
    }

    &:hover {
      transition: 0.7s;
      color: ${({ theme }) => theme.colors.grey[200]};
    }
  }
`;
